import script from "./ContactIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactIcon.vue?vue&type=script&setup=true&lang=ts"

import "./ContactIcon.vue?vue&type=style&index=0&id=b604c536&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b604c536"]])

export default __exports__